// extracted by mini-css-extract-plugin
module.exports = {"bgTop":"archivecrops-module--bgTop--1oz1x","bgBottom":"archivecrops-module--bgBottom--4JGCS"};